/* ── LoginPage ── */
export const LOGIN_PAGE_TEXT = {
  heroImageAlt: 'HRMS Hero',
  welcomeTitle: 'Welcome back',
  welcomeSubtitle: 'Sign in to your PeopleSuite account',
  emailLabel: 'Email address',
  emailPlaceholder: 'you@company.com',
  passwordLabel: 'Password',
  passwordPlaceholder: 'Enter your password',
  rememberMeLabel: 'Remember me',
  signInButton: 'Sign In',
  generatePasswordLink: 'Forgot password?',
} as const;

/* ── ResetPasswordPage ── */
export const RESET_PASSWORD_TEXT = {
  heroImageAlt: 'HRMS Hero',
  invalidLinkTitle: 'Invalid Reset Link',
  invalidLinkSubtitle: 'This password reset link is invalid or has expired.',
  requestNewLinkButton: 'Request New Link',
  formTitle: 'Reset Password',
  formSubtitle: 'Enter your new password below',
  newPasswordLabel: 'New Password',
  confirmPasswordLabel: 'Confirm New Password',
  togglePasswordVisibility: 'toggle password visibility',
  toggleConfirmPasswordVisibility: 'toggle confirm password visibility',
  submitButton: 'Reset Password',
  backToLogin: 'Back to Login',
  successTitle: 'Password Reset Successful',
  successSubtitle: 'Your password has been successfully reset.',
  loginStateMessage: 'Password reset successful! You can now log in with your new password.',
  signInButton: 'Sign In',
} as const;

export const RESET_PASSWORD_ERRORS = {
  invalidOrMissingToken: 'Invalid or missing reset token',
  passwordRequired: 'Password is required',
  passwordTooShort: 'Password must be at least 8 characters',
  passwordComplexity: 'Password must contain uppercase, lowercase, and number',
  confirmPasswordRequired: 'Please confirm your password',
  passwordsDoNotMatch: 'Passwords do not match',
} as const;

/* ── AuthContext ── */
export const AUTH_ERRORS = {
  genericError: 'An error occurred',
} as const;
